import { ReactNode, createContext, useCallback } from 'react'
import { Box } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'
import { useLocation } from '@reach/router'

import { layoutStyles as styles } from 'src/components/Layout/LayoutStyles'
import Header from 'src/components/Layout/components/Header/Header'
import * as routes from 'src/constants/routes'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import Footer from './components/Footer/Footer'
import NoConnectionDialog from './components/NoConnectionDialog'
import SideMenu from './components/SideMenu'

// eslint-disable-next-line
export const ConnectToLexnetDialogContext = createContext(() => {})

type Props = {
  children?: ReactNode
}

export default function Layout({ children }: Props): JSX.Element {
  const {
    connected,
    setNoConnectionOpen,
    noConnectionOpen,
    onConnect,
    onDisconnect,
    onClose
  } = useLexnetStatusContext()

  const location = useLocation()
  const hasFooter =
    location.pathname === routes.MESSAGES() || location.pathname === routes.COOKIE_POLICY

  const showConnectDialog = useCallback(() => {
    setNoConnectionOpen(true)
    // eslint-disable-next-line
  }, [])

  return (
    <ConnectToLexnetDialogContext.Provider value={showConnectDialog}>
      <CssBaseline />
      <NoConnectionDialog open={noConnectionOpen} onClose={onClose} onConnect={onConnect} />
      <Header
        onConnect={showConnectDialog}
        onDisconnect={onDisconnect}
        lexnetConnected={connected}
      />

      {/* <Box sx={styles.toolbar} /> */}

      <Box
        component="div"
        sx={styles.container}
        display="flex"
        className={hasFooter ? 'noScroll' : ''}
      >
        <SideMenu />
        <Box component="main" sx={styles.content} className={hasFooter ? 'noScroll' : ''}>
          {children}
        </Box>
      </Box>
      {hasFooter && <Footer />}
    </ConnectToLexnetDialogContext.Provider>
  )
}
